import { render, staticRenderFns } from "./CaseFile.vue?vue&type=template&id=de3d64d4"
import script from "./CaseFile.vue?vue&type=script&lang=js"
export * from "./CaseFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports